import Model, { attr } from '@ember-data/model';

export default class AppointmentClientModel extends Model {
  @attr() fee;
}
